export default "__VITE_ASSET__xTPV$_Jsulbg4jHfVf9Bng__"